import { IDropdownStyles } from "@fluentui/react";
import Moment from "moment";
import { decimalFormatter } from "@/utils/numberFormatter";
import { TReporting } from "@/screen/Portfolios/Summary/types/PortfolioTypes";

export const exportHeaders =
[
    'Nombre Fondo',
    'Isin',
    'Comprado',
    'Títulos',
    'Valoración',
    'Fecha VL',
    'Revalorización',
    'Peso',
    'V. Liq',
    'Currency',
    'TC'
];

export const dropdownStyles: Partial<IDropdownStyles> =
{
    caretDown:
    {
        color: "#cc214F",
        fontSize: "14px !important",
        fontWeight: 700
    },
    dropdownItems:
    {
        color: "#cc214F !important",
        borderColor: "transparent !important",
        fontWeight: 500,
        fontSize: "20px",
        marginTop: "5px"
    },
    title:
    {
        color: "#cc214F !important",
        borderColor: "transparent !important",
        fontWeight: 500,
        fontSize: "20px",
        marginTop: "5px"
    },
    dropdownItemSelected:
    {
        backgroundColor: "white"
    },
    dropdownOptionText: { color: "#cc214F !important" }
};

export const rateTooltip = "Time-Weighted Rate of Return es el estándar de medición recomendado por las normas GIPS, ya que permite comparar los resultados de la gestión al eliminar el efecto de las aportaciones y reintegros de efectivo en el periodo de cálculo. La rentabilidad es calculada diariamente y compuesta según:\n (1+r1)x(1+r2)x(1+r3) x … x (1+ rn) = (1+r).\n Donde r son las rentabilidades diarias";

export const buildDateFlags = (ops: any[], finametrixContract: string): any[] =>
{
    const opArray: any[] = [];

    ops.forEach((op: any) =>
    {
        const description: string = op.cashIn ? op.description : op.title;
        opArray.push(
        {
            id: op.id,
            operationAt: Moment(op.operationAt).format('YYYY-MM-DD'),
            settlementDate: Moment(op.settlementDate).format('YYYY-MM-DD'),
            operationInstrument:
            {
                isin: op.operationInstrument.isin,
                name: op.operationInstrument.name
            },
            description: description,
            amount: op.amount,
            nav: op.nav,
            exchangeRate: op.exchangeRate === 1 ? op.exchangeRate : decimalFormatter.format(op.exchangeRate),
            titles: op.titles,
            currency: op.currency
        });
    });

    const dateFlag: any[] = [];
    const color: string = '#4284E6';

    opArray.forEach((op: any) =>
    {
        const offset = Moment().utcOffset();
        const date = Moment(op.operationAt).add(offset, "minutes").locale("es");
        const dateString = new Date(op.operationAt).toLocaleDateString();
        const isin = op.operationInstrument.isin;
        const name = op.operationInstrument.name;

        const existingIdx = dateFlag.findIndex((i: any) => i.date === dateString);

        if(existingIdx !== -1)
        {
            const alreadyExists =
                dateFlag[existingIdx].operations.findIndex((j: any) => j.isin === isin) !== -1 &&
                dateFlag[existingIdx].operations.findIndex((k: any) => k.operationId === op.operationId) !== -1;

            if(!alreadyExists)
            {
                dateFlag[existingIdx].operations.push(
                {
                    text: op.description,
                    fundName: name,
                    amount: op.amount,
                    isin: isin,
                    titles: op.titles,
                    currency: op.currency,
                    operationId: op.id,
                    contract: finametrixContract
                });
            }
        }
        else
        {
            dateFlag.push(
            {
                x: date.valueOf(),
                date: dateString,
                title: 'i',
                operations:
                [
                    {
                        text: op.description,
                        fundName: name,
                        isin: isin,
                        amount: op.amount,
                        titles: op.titles,
                        currency: op.currency,
                        operationId: op.id,
                        contract: finametrixContract
                    }
                ],
                lineColor: color,
                color: color,
                fillColor: color,
                stroke: '#000',
                shape: 'circlepin'
            });
        }
    });

    return dateFlag;
};

export const buildEmptyPerformanceSeries = (): any[] =>
[
    {
        name: "Cartera",
        data: [],
        showInLegend: true,
        tooltip:
        {
            valueDecimals: 2
        }
    }
];

export const buildEmptyMoneySeries = (): any[] =>
[
    {
        name: "Cartera en Euros",
        id: "portfolio",
        data: [],
        showInLegend: true,
        tooltip:
        {
            valueDecimals: 2
        }
    },
    {
        name: "Operaciones Realizadas",
        type: "flags",
        showInLegend: true,
        onSeries: "portfolio",
        data: []
    }
];

export const initialReporting: TReporting =
{
    hasError: false,
    positions:
    {
        positionsTo:
        {
            positions: [],
            aggregation: []
        }
    },
    performance:
    {
        serie: [{ dateAsString: "", accReturn: 0 }]
    },
    totalAmount: 0
};